import { Controller } from '@hotwired/stimulus'


/*
partner_alpa.png
partner_eko.png
partner_ffcam.png
partner_vf.png
partner_vieux-campeur.png
 */

const images = {
  'no_image.png': require('respimg+file:../../images/no_image.png?sizes=400w,800w&outputFormats=webp,png'),
  'partner_alpa.png': require('respimg+file:../../images/partner_alpa.png?sizes=400w, 300w, 100w&outputFormats=webp,png'),
  'partner_eko.png': require('respimg+file:../../images/partner_eko.png?sizes=1000w, 800w, 300w, 100w&outputFormats=webp,png'),
  'partner_ffcam.png': require('respimg+file:../../images/partner_ffcam.png?sizes=1000w, 800w, 300w, 100w&outputFormats=webp,png'),
  'partner_vf.png': require('respimg+file:../../images/partner_vf.png?sizes=400w, 300w, 100w&outputFormats=webp,png'),
  'partner_vieux-campeur.png': require('respimg+file:../../images/partner_vieux-campeur.png?sizes=400w, 300w, 100w&outputFormats=webp,png'),
  'hero.jpg': require('respimg+file:../../images/hero.jpg?sizes=1600w, 1000w, 600w, 300w, 100w&outputFormats=webp,jpg'),
} as Record<string, Image>


// example of respimg+file format :
/*
{
  "height": 83,
  "originalHeight": 400,
  "originalWidth": 482,
  "sources": [
    [
      "image/webp",
      "../alpa.100w-B4ZTNV57.webp 100w,../alpa.300w-VBNKYXDQ.webp 300w"
    ],
    [
      "image/png",
      "../alpa.100w-ZVJRU7ZW.png 100w,../alpa.300w-DYRSVTKF.png 300w"
    ]
  ],
  "src": "../alpa.100w-ZVJRU7ZW.png",
  "width": 100
}
 */

interface Image {
  height: number
  originalHeight: number
  originalWidth: number
  sources: string[][]
  src: string
  width: number
}

const assetPath = '/assets/built'

export default class extends Controller {
  static targets = [ 'picture' ]

  static values = {
    sourcePath: String,
    imgClass: String,
    imgStyles: String,
    sizes: String,
    loading: String,
    alt: String,
  }

  private host: string = 'http://localhost:3000'

  declare pictureTarget: HTMLElement
  declare sourcePathValue: string
  declare imgClassValue: string
  declare imgStylesValue: string
  declare sizesValue: string
  declare loadingValue: string
  declare hasSizesValue: boolean
  declare hasLoadingValue: boolean
  declare altValue: string
  declare hasAltValue: boolean

  connect() {
    this.host = window.location.origin

    console.log('connect responsive picture controller')

    this.construct()
  }

  construct() {
    console.log("Hoé ?")
    const picture = this.pictureTarget
    const source = images[this.sourcePathValue]

    console.log('source', source)
    if (source) {
      source.sources.forEach((sourceSet, index) => {
        const [ type, srcset ] = sourceSet
        const sourceElem = document.createElement('source')
        sourceElem.setAttribute('type', type)
        if (this.hasSizesValue) sourceElem.setAttribute('sizes', this.sizesValue)
        sourceElem.setAttribute('srcset', replaceAll(srcset, '..', this.host + assetPath))
        picture.appendChild(sourceElem)
      })

      const img = document.createElement('img')
      img.setAttribute('src', `${this.host}${assetPath}/images/${this.sourcePathValue}`)
      img.setAttribute('style', this.imgStylesValue)
      img.setAttribute('class', this.imgClassValue)
      if (this.hasLoadingValue) img.setAttribute('loading', this.loadingValue)
      if (this.hasAltValue) img.setAttribute('alt', this.altValue)

      picture.appendChild(img)
    } else {
      console.error(`No image found for ${this.sourcePathValue}`)
    }
  }


}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}
